class PrinterRequest {
    kullaniciId?: number;
    lazerPrinter?: string;
    barcodePrinter?: string;
    macAddress?: string;
}
export default PrinterRequest;